<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn fab small v-on="on" color="warning" class="ma-2" :loading="loading">
        <v-icon>mdi-swap-horizontal</v-icon>
      </v-btn>
    </template>
    <v-list v-if="resources && resources.length > 0">
      <v-list-item
        v-for="(resource, index) in resources"
        :key="index"
        @click="$emit('click',resource)"
      >
        <v-list-item-title>{{ resource.description }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import resourceService from "@/services/resourceService";
export default {
  name: "reg-resource-menu",
  props: ["resourceId", "loading"],
  data() {
    return {
      resources: [],
    };
  },
  watch: {
    async stageTypeId() {
      await this.getResources();
    },
  },
  computed: {
    resourcesComp() {
      let res = this.resources.find(function (r) {
        return r.id != this.resourceId;
      });

      return res;
    },
  },
  methods: {
    async getResources() {
      if (this.resourceId == null) return;
      let res = await resourceService.getResourcesSameStageTypeByResourceId(
        this.resourceId
      );

      if (res.success) {
        this.resources = res.data.sort((a, b) => {
          if (a.description > b.description) return 1;
          else if (a.description < b.description) return -1;
          else return 0;
        });
      }
    },
  },
  async mounted() {
    await this.getResources();
  },
};
</script>